import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors} from '@angular/common/http';
import { JWT_OPTIONS, JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { provideNgxMask } from 'ngx-mask';
import { AuthInterceptor } from './core/interceptor/auth-interceptor';
import { AuthService } from './core/services/auth.service';
import { UnauthorizedCheckService } from './core/interceptor/unauthorized-check.service';
import { SocketInterceptor } from './core/interceptor/socket.interceptor';
import { AngularSvgIconModule } from 'angular-svg-icon';

export const appConfig: ApplicationConfig = {
  providers: [
    // One change detection per browser event, not one per listener - a click
    // reaching several document:click listeners (filters, sidebar, menus)
    // re-rendered a whole CRM board once for each of them.
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        AuthInterceptor,
        SocketInterceptor
      ])
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedCheckService,
      multi: true
    },
    JwtHelperService,
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS,
    },
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: () => localStorage.getItem('custm_token') ?? '',
          allowedDomains: [
            '127.0.0.1:8000',
            'localhost:8000',
            'localhost:8001',
            'localhost',
            'staging.appv2.custm.com.au'
          ]
        }
      }),
      NgxLoadingModule.forRoot({
        animationType: ngxLoadingAnimationTypes.wanderingCubes,
        backdropBackgroundColour: "rgba(0,0,0,0.1)",
        backdropBorderRadius: "4px",
        primaryColour: "#ffffff",
        secondaryColour: "#ffffff",
        tertiaryColour: "#ffffff",
        fullScreenBackdrop: true
      }),
      AngularSvgIconModule.forRoot()
    ),
    provideAnimations(),
    provideNgxMask()
  ],
};

export const appEnv = {
  production: environment.production,
  dev: environment.development,
  stage: environment.stage,
  api: environment.apiUrl,
  mapboxAccessToken: environment.mapboxgl_access_token,
  onboarding: environment.onboarding,
  s3Url: environment.s3Url,
  pusher: environment.pusher,
  firebaseConfig: environment.firebaseConfig,
  timezone: 'Australia/Melbourne'
};
